/**
 * Function to setup a redux store with the application's
 * middlewares.
 */

import {combineReducers, configureStore} from '@reduxjs/toolkit';
import {isDev} from '@src/config';

const initStore = (reducers, preloadedState) => {
  return configureStore({
    reducer:
      typeof reducers === 'object' ? combineReducers(reducers) : reducers,
    preloadedState,
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware({
        // WARNING! The checks here are valuable but they have a
        // significant impact on performance.
        serializableCheck: false,
        immutableCheck: false,
      }),
    devTools:
      isDev || window.location.hostname === 'static.prod.planet-labs.com',
  });
};

export default initStore;
